import { supportAssistantOrigin } from '../constants/appConstants';

/**
 * Build the src for the support assistant iframe.
 *
 * `userName` / `userEmail` are read by the Space itself
 * (get_username_from_request in bh_support_doc_chatbot/app.py) to attribute the
 * "unanswered question" alert it emails to support. They are not authentication
 * — the Space is public — so nothing secret belongs in this URL.
 *
 * `__theme` is Gradio's own query parameter, and today it has NO visible
 * effect: the Space's own stylesheet (the `css=` block in app.py) pins every
 * Gradio colour variable to the dark palette with `!important`, so the chat
 * renders dark whatever we ask for. It is sent anyway because it costs nothing
 * and is the right request the moment that stylesheet stops forcing dark —
 * until then, a light-themed app shows a light panel header above a dark chat.
 *
 * It is resolved ONCE, when the iframe is first created, and deliberately not
 * kept in sync afterwards: changing the src reloads the iframe, and reloading
 * it throws away the conversation the user is in the middle of. A theme switch
 * mid-chat is far rarer than a chat, so the panel keeps the theme it opened
 * with until the next full page load.
 */
export const buildAssistantUrl = ({ email, name, theme } = {}) => {
  const params = new URLSearchParams({
    userEmail: email || '',
    userName: name || '',
    __theme: theme === 'light' ? 'light' : 'dark'
  });

  return `${supportAssistantOrigin()}/?${params.toString()}`;
};
